import { createContext, useContext } from "react";

import type { StockPageContextValue } from "./types";

export const StockPageContext = createContext<StockPageContextValue | null>(
  null
);

export function useStockPage(): StockPageContextValue {
  const value = useContext(StockPageContext);
  if (!value) {
    throw new Error("useStockPage must be used within StockPageProvider");
  }
  return value;
}

export function useStockPageOptional(): StockPageContextValue | null {
  return useContext(StockPageContext);
}
